import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { SidebarProvider, useSidebar } from './contexts/SidebarContext';
import { Toaster } from './components/ui/sonner';
import Sidebar from './components/Sidebar';
import PWAInstallPrompt from './components/PWAInstallPrompt';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Clientes from './pages/Clientes';
import Productos from './pages/Productos';
import Servicios from './pages/Servicios';
import Dominios from './pages/Dominios';
import Proveedores from './pages/Proveedores';
import ArquitecturaDB from './pages/ArquitecturaDB';
import StackLAMP from './pages/StackLAMP';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import './App.css';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-[#0d0f14]">
        <div className="text-[#4f9eff] font-['IBM_Plex_Mono'] text-lg">Cargando...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

const AppLayout = ({ children }) => {
  const { isMobile } = useSidebar();
  
  return (
    <div className="flex h-screen bg-[#0d0f14] overflow-hidden">
      <Sidebar />
      <div className={`flex-1 ${isMobile ? 'ml-0' : 'ml-64'} transition-all duration-300`}>
        {children}
      </div>
    </div>
  );
};

function App() {
  // Register service worker for PWA
  useEffect(() => {
    serviceWorkerRegistration.register();
  }, []);

  return (
    <AuthProvider>
      <SidebarProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <AppLayout>
                    <Dashboard />
                  </AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/clientes"
              element={
                <ProtectedRoute>
                  <AppLayout>
                    <Clientes />
                  </AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/productos"
              element={
                <ProtectedRoute>
                  <AppLayout>
                    <Productos />
                  </AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/servicios"
              element={
                <ProtectedRoute>
                  <AppLayout>
                    <Servicios />
                  </AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/dominios"
              element={
                <ProtectedRoute>
                  <AppLayout>
                    <Dominios />
                  </AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/proveedores"
              element={
                <ProtectedRoute>
                  <AppLayout>
                    <Proveedores />
                  </AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/arquitectura"
              element={
                <ProtectedRoute>
                  <AppLayout>
                    <ArquitecturaDB />
                  </AppLayout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/stack"
              element={
                <ProtectedRoute>
                  <AppLayout>
                    <StackLAMP />
                  </AppLayout>
                </ProtectedRoute>
              }
            />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
          </Routes>
          <PWAInstallPrompt />
        </BrowserRouter>
        <Toaster position="top-right" theme="dark" />
      </SidebarProvider>
    </AuthProvider>
  );
}

export default App;